export const pop = (message, type, icon) => {
  let event;
  event = new CustomEvent("message", {
    detail: {
      message,
      type,
      icon,
    },
  });
  window.dispatchEvent(event);
};

export const message = (message, icon) => {
  pop(message, "dark", icon || "fa fa-comment");
};

export const primary = (message, icon) => {
  pop(message, "primary", icon || "fa fa-bullhorn");
};

export const secondary = (message, icon) => {
  pop(message, "secondary", icon || "fa fa-bell-o");
};

export const info = (message, icon) => {
  pop(message, "info", icon || "fa fa-info");
};

export const success = (message, icon) => {
  pop(message, "success", icon || "fa fa-check");
};

export const danger = (message, icon) => {
  pop(message, "danger", icon || "fa fa-exclamation-triangle");
};

export const warning = (message, icon) => {
  pop(message, "warning", icon || "fa fa-exclamation-circle");
};
